import DatePicker from 'react-datepicker';

import styles from './CalendarPicker.module.scss';

export interface DateRangeValue {
  after?: Date;
  before?: Date;
}

const endOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate(), 23, 59, 59);

type RangeProps = {
  mode: 'range';
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  monthsShown?: number;
};

type SingleProps = {
  mode?: 'single';
  value: Date | undefined;
  onChange: (date: Date | undefined) => void;
  monthsShown?: number;
};

export type CalendarPickerProps = RangeProps | SingleProps;

export const CalendarPicker = ({ mode, value, onChange, monthsShown: monthsShownProp }: CalendarPickerProps) => {
  const monthsShown = monthsShownProp ?? (mode === 'range' ? 2 : 1);

  if (mode === 'range') {
    const rangeValue = value as DateRangeValue;
    const rangeOnChange = onChange as (v: DateRangeValue) => void;
    return (
      <div className={styles.calWrap}>
        <DatePicker
          selectsRange
          startDate={rangeValue.after ?? null}
          endDate={rangeValue.before ?? null}
          onChange={([start, end]) =>
            rangeOnChange({ after: start ?? undefined, before: end ? endOfDay(end) : undefined })
          }
          monthsShown={monthsShown}
          inline
          calendarStartDay={1}
          showPopperArrow={false}
        />
      </div>
    );
  }

  const singleValue = value as Date | undefined;
  const singleOnChange = onChange as (d: Date | undefined) => void;
  return (
    <div className={styles.calWrap}>
      <DatePicker
        selected={singleValue ?? null}
        onChange={date => singleOnChange(date ?? undefined)}
        monthsShown={monthsShown}
        inline
        calendarStartDay={1}
        showPopperArrow={false}
      />
    </div>
  );
};
